const BritamBancaModuleID = "britam-banca-coop-47b4-4b5e-8978-2b47fb716f8e"
const BymModuleID = "britam-bym-0425c66a-e47a-4471-a243-d0cc592661e3"

export {BritamBancaModuleID, BymModuleID}